
/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

Mindbreeze.define('service/stub',[
    "underscore",
    "backbone",
    "utils/trace",
    "service/channel"
  ], function(
    _,
    Backbone,
    Trace,
    Channel
  ) {

  
  var Stub = function(options) {
    if (options && options.path)
      this.path = options.path;
  }
  
  _.extend(Stub.prototype, {

    getDataType: function(channel, request) {
      return {"dataType": this.dataType};
    },

    // **call** sends this requests over the channel and passing observer, 
    // return either the response of the channel or false,null,undefined                                            
    call: function(channel, request, responseObserver) {
        if (_.isFunction(channel.prepareRequest)) {
          request = _.clone(request);
          channel.prepareRequest(request);
        }
        try {
          var serviceURL = channel.get("url") + (this.path || "");      
          if (request && request.user_context) {
            request.user_context.service_url = serviceURL;
          }
        } catch (e) {          
        }
      
        return channel.call(this.path, request, responseObserver, this.getDataType(channel, request));
    },
    
    // **cast** distribute over multiple channels
    cast: function(channels, request, responseObserver, options) {
      var that = this;

      var promises = [];
      var responsePromise = new Channel.DeferredCallFinished();
      var multiResponseObserver;
      var running = 0;
      
      var forEachChannel;
      if (_.isArray(channels)) {
          forEachChannel = _.bind(_.each, _, channels);
      }
      else if (_.isFunction(channels && channels.each)) {
          forEachChannel = _.bind(channels.each, channels);
      }
      else {
          forEachChannel = function(callback) {
              callback(channels);
          }
      }

      if (responseObserver) {
        var MultiResponseObserver = function () {};
        _.extend(MultiResponseObserver.prototype, Backbone.Events);
        multiResponseObserver = new MultiResponseObserver();

        multiResponseObserver.traceContext = responseObserver.traceContext;

        multiResponseObserver.on("all", function (type) {
          if (/response|error/.test(type)) {
            running--;
            var computing = running > 0;
          }
          var args = _.toArray(arguments);
          while (args.length < 3 + 1 /* offset for event type */) {
             args.push(this);
          }
          args.push(computing);
          responseObserver.trigger.apply(responseObserver, args);
        })
      }
      forEachChannel(function(channel) {
        if ((!channel || !channel.prepareRequest) && (channels && channels.prepareRequest)) {
          request = _.clone(request);
          channels.prepareRequest(channel, request);
        }
        var output = that.call(channel, request, multiResponseObserver, options);
        if (output) {
          running++;
          promises.push(output);
        }
        
      });
      
      if (promises.length == 0) responsePromise.triggerFail();
      else {
        var i = 0;
        function callback() {
          // get the current i is passed as the this object
          var next = i++;
          if (next >= promises.length) {
            responsePromise.triggerDone();
          }
          else {
            promises[next].always(callback, next);
          }
        }
        promises[0].always(callback, 0);
      }
      return responsePromise;
    }
  });
  
  Stub.extend = Backbone.Model.extend;
  
  return Stub;
});
